import { Suspense, use, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { User } from "../../../models";
import { fetchUserById } from "./data";

import NotFound from "./notFound";
import Breadcrumbs from "../../../components/breadcrumbs";
import EditForm from "./ui/edit-form";
import UserEditSkeleton from "./ui/skeletons/userEditSkeleton";

export default function UserEditPage() {
  const { id } = useParams<{ id: string }>();
  const [user, setUser] = useState<User>(new User());
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchUser() {
      try {
        if (id) {
          const user = await fetchUserById(id);
          if (user) {
            setUser(user);
          }
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
      setLoading(false);
    }
    fetchUser();
  }, [id]);

  if (!user.id && !loading) {
    return <NotFound></NotFound>;
  }

  return (
    <main>
      <Breadcrumbs
        breadcrumbs={[
          { label: "Users", href: "/admin/users" },
          {
            label: "Edit User",
            href: `/admin/users/edit/${id}`,
            active: true,
          },
        ]}
      />
      {
        loading?<UserEditSkeleton />:<EditForm user={user} />
      }
      
    </main>
  );
}
